// extracted by mini-css-extract-plugin
export default {"loaderSection":"loader_loaderSection__5nNaS","loaderSecitionh1":"loader_loaderSecitionh1__ZVDzV","lds_ring":"loader_lds_ring__F-e3Z"};